module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal"
  }, [_c('div', {
    staticClass: "protal-title"
  }, [_vm._v("\n\t\t热门" + _vm._s(_vm.type === 'web' ? '综合门户' : '移动媒体') + "\n\t\t"), _c('span', {
    staticClass: "text-lighter"
  }, [_vm._v("\n\t\t\t优选" + _vm._s(_vm.type === 'web' ? '全网精品综合门户' : '移动端') + "媒体，" + _vm._s(_vm.type === 'web' ? '高价值曝光' : '精品流量') + "引爆品牌传播\n\t\t")])]), _vm._v(" "), (this.proData.length) ? _c('div', {
    staticClass: "protal-content clearfix contain"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('transition-group', {
    staticClass: "clearfix",
    attrs: {
      "name": "list-complete",
      "tag": "span"
    }
  }, _vm._l((_vm.proData), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "protal-icons",
      class: _vm.type === "web" ? "pc" : "mobile"
    }, [(_vm.type === "web") ? _c('a', {
      attrs: {
        "href": item.domain,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + item.logo,
        "alt": ""
      }
    })]) : _c('a', {
      on: {
        "click": function($event) {
          _vm.showDetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + item.logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-center",
      staticStyle: {
        "margin-top": "10px",
        "height": "16px",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "turn clearfix"
  }, [_c('div', {
    staticClass: "turn-left pull-left",
    on: {
      "click": function($event) {
        _vm.changePage(-1)
      }
    }
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "turn-right pull-right",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-circle-right"
  })])])]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n\t\t暂无数据！\n\t")]), _vm._v(" "), (this.proData.length) ? _c('Modal', {
    staticClass: "modal-special",
    attrs: {
      "modal": _vm.modal
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    slot: "body"
  }, [_c('span', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer",
      "position": "absolute",
      "top": "-24px",
      "right": "0",
      "width": "80px",
      "height": "40px",
      "text-align": "center",
      "background-color": "#f5700e",
      "color": "white",
      "line-height": "40px",
      "box-shadow": "0 0 3px 0 rgba(0, 0, 0, 0.5)"
    },
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('div', {
    staticClass: "modal--body"
  }, [_c('div', {
    staticClass: "modal--header"
  }, [_vm._v("\n\t\t\t\t\t广告位案例展示\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal--content"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl + _vm.proData[_vm.nowIndex].preview_pic,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal--content--right"
  }, [_c('div', {
    staticClass: "modal-des"
  }, [_c('div', {
    staticClass: "des-line"
  }, [_vm._v(_vm._s(_vm.proData[_vm.nowIndex].name) + _vm._s(+_vm.proData[_vm.nowIndex].type === 2 ? '(WAP)' : '(APP)'))]), _vm._v(" "), _c('div', {
    staticClass: "des-line"
  }, [_vm._v("广告位查看路径：" + _vm._s(_vm.proData[_vm.nowIndex].preview_url))]), _vm._v(" "), _c('div', {
    staticClass: "des-line"
  }, [_vm._v(_vm._s(_vm.proData[_vm.nowIndex].m_domain !== "" ? "网址：" : "") + _vm._s(_vm.proData[_vm.nowIndex].m_domain))])]), _vm._v(" "), _c('div', {
    staticClass: "modal--footer"
  }, [(this.proData.length) ? _c('div', {
    staticClass: "protal-content clearfix contain"
  }, [_c('div', {
    staticClass: "turnbtn",
    on: {
      "click": function($event) {
        _vm.changePage(-1)
      }
    }
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-turn-left"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "498px",
      "float": "left"
    }
  }, [_c('transition-group', {
    staticClass: "clearfix",
    attrs: {
      "name": "list-complete",
      "tag": "span"
    }
  }, _vm._l((_vm.proData), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "protal-icons mobile",
      class: index === _vm.nowIndex ? "active" : ""
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.changeIndex(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgUrl + item.logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.name.substring(0, 4)))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "turnbtn",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-turn-right"
  })])]) : _vm._e()])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77dca40a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medianav/portal/portal.vue
// module id = 448
// module chunks = 2